<template>

    <!-- SIDEBAR -->
    <div class="hp-sidebar hp-bg-color-black-20 hp-bg-color-dark-90 border-end border-black-40 hp-border-color-dark-80">
        <div class="hp-sidebar-container">
            <div class="hp-sidebar-header-menu">
                <div class="row justify-content-between align-items-end mx-0">
                    <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-visible">
                        <div class="hp-cursor-pointer">
                            <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                    fill="#B2BEC3"></path>
                                <path
                                    d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                    fill="#B2BEC3"></path>
                            </svg>
                        </div>
                    </div>

                    <div class="w-auto px-0">
                        <div class="hp-header-logo d-flex align-items-center">
                            <router-link :to="{ name: 'users' }" class="position-relative">


                                <img class="hp-logo hp-sidebar-visible hp-dark-none" src="@/assets/img/favicon.png"
                                    alt="logo">
                                <img class="hp-logo hp-sidebar-visible hp-dark-block" src="@/assets/img/favicon.png"
                                    alt="logo">
                                <img class="hp-log hp-sidebar-hidden hp-dir-none hp-dark-none"
                                    src="@/assets/img/logo_long_black.png" alt="logo" style="width: 150px; ">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block"
                                    src="@/assets/img/favicon.png" alt="logo">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none"
                                    src="@/assets/img/favicon.png" alt="logo">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block"
                                    src="@/assets/img/favicon.png" alt="logo">
                            </router-link>

                            
                        </div>
                    </div>

                    <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-hidden" >
                        <div class="hp-cursor-pointer mb-4" style="margin-top: -45px;">
                            <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                    fill="#B2BEC3"></path>
                                <path
                                    d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                    fill="#B2BEC3"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <ul>
                    <li>

                        <ul>
                            <li>
                                <router-link :to="{ name: 'users' }" id="usersN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Users" data-bs-original-title="Users"
                                        aria-label="Users"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-People"></i>
                                        </span>


                                        <span class="titleS">Users</span>
                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'models' }" id="modelsN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Users" data-bs-original-title="Users"
                                        aria-label="Users"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-People"></i>
                                        </span>


                                        <span class="titleS">Models</span>
                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'payouts' }" id="payoutsN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Payouts"
                                        data-bs-original-title="Payouts" aria-label="Payouts"></div>


                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Wallet"></i>
                                        </span>

                                        <span class="titleS">Payouts
                                            
                                        </span>

                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'ref' }" id="refN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Referral"
                                        data-bs-original-title="Refferals" aria-label="Referrals"></div>


                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Wallet"></i>
                                        </span>

                                        <span class="titleS">Referral payouts
                                            
                                        </span>

                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'kyc' }" id="kycN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Kyc" data-bs-original-title="Kyc"
                                        aria-label="Kyc"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Category"></i>
                                        </span>

                                        <span class="titleS">Kyc</span>

                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'reports' }" id="ReportsN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Reports" data-bs-original-title="Reports"
                                        aria-label="Reports"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Danger"></i>
                                        </span>

                                        <span class="titleS">Reports</span>

                                    </span>
                                </router-link>
                            </li>

                            <li style="margin-top: 50px;">
                                <button class="btn btn-primary" @click="refreshSubs"> 
                                    <i class="hp-text-color-dark-0 ri-2x ri-refresh-line" style="padding-right: 5px;"></i>
                                    Refresh subs
                                </button>
                            </li>


                        </ul>
                    </li>


                </ul>
            </div>

            <div class="row justify-content-between align-items-center hp-sidebar-footer mx-0 hp-bg-color-dark-90">
                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>

                <div class="col">
                    <div class="row align-items-center">
                        <div class="w-auto px-0">
                            <div>
                                <img src="https://api.dicebear.com/9.x/initials/svg?seed=Baesnap%20Admin"
                                    style="width: 58px; height: 58px; border-width: 0px; border-radius: 50%;  object-fit: cover; border-color: #000; border-width: 1px; border-style: solid;"
                                    class="hp-img-cover">
                            </div>
                        </div>

                        <div class="w-auto ms-8 px-0 hp-sidebar-hidden mt-4">
                            <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS">Baesnap Admin</span>
                            <a href="javascript:;" class="hp-badge-text fw-normal hp-text-color-dark-30">@baesnap-admin</a>
                        </div>
                    </div>
                </div>

                <div class="col hp-flex-none w-auto px-0 hp-sidebar-hidden">
                    <div>
                        <div>
                            <i class="hp-text-color-dark-0 hp-text-color-black-80 iconly-Light-Setting"></i>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- MOBILE NAV -->
    <div class="offcanvas offcanvas-start hp-mobile-sidebar bg-black-20 hp-bg-dark-90" tabindex="-1" id="mobileMenu"
        aria-labelledby="mobileMenuLabel" style="width: 256px;">
        <div class="offcanvas-header justify-content-between align-items-center ms-16 me-8 mt-16 p-0">
            <div class="w-auto px-12" style="margin-top: 10px; ">
                <div class="hp-header-logo d-flex align-items-center">
                    <div class="col"
                        style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; width: 100%;">
                        <div class="row align-items-center">
                            <div class="w-auto px-0">
                                <div>
                                    <img src="https://api.dicebear.com/9.x/initials/svg?seed=Baesnap%20Admin"
                                        style="width: 58px; height: 58px; border-width: 0px; border-radius: 50%;  object-fit: cover; border-color: #000; border-width: 1px; border-style: solid;"
                                        class="hp-img-cover">
                                </div>
                            </div>


                        </div>
                        <div class="w-auto  px-0 hp-sidebar-hidden mt-8" style="margin-left: -8px;">
                            <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS"
                                style="font-weight: 900;">Baesnap Admin</span>
                            <div
                                class="hp-badge-text fw-normal hp-text-color-dark-30">@baesnap-admin</div>
                        </div>
                    </div>



                </div>
            </div>

            <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-hidden" data-bs-dismiss="offcanvas"
                aria-label="Close" style="position: absolute; top: 30px; right: 10px;">
                <button type="button" class="btn btn-text btn-icon-only bg-transparent">
                    <i class="ri-close-fill lh-1 hp-text-color-black-80" style="font-size: 24px;"></i>
                </button>
            </div>
        </div>

        <div
            class="hp-sidebar hp-bg-color-black-20 hp-bg-color-dark-90 border-end border-black-40 hp-border-color-dark-80">
            <div class="hp-sidebar-container">
                <div class="hp-sidebar-header-menu">
                    <div class="row justify-content-between align-items-end mx-0">
                        <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-visible">
                            <div class="hp-cursor-pointer">
                                <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                        fill="#B2BEC3"></path>
                                    <path
                                        d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                        fill="#B2BEC3"></path>
                                </svg>
                            </div>
                        </div>

                        <div class="w-auto px-0">
                            <div class="hp-header-logo d-flex align-items-center">
                                <div class="position-relative">
                                    <div class="hp-header-logo-icon position-absolute bg-black-20 hp-bg-dark-90 rounded-circle border border-black-0 hp-border-color-dark-90 d-flex align-items-center justify-content-center"
                                        style="width: 18px; height: 18px; top: -5px;">
                                        <svg class="hp-fill-color-dark-0" width="12" height="12" viewBox="0 0 12 12"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.709473 0L1.67247 10.8L5.99397 12L10.3267 10.7985L11.2912 0H0.710223H0.709473ZM9.19497 3.5325H4.12647L4.24722 4.88925H9.07497L8.71122 8.95575L5.99397 9.70875L3.28047 8.95575L3.09522 6.87525H4.42497L4.51947 7.93275L5.99472 8.33025L5.99772 8.3295L7.47372 7.93125L7.62672 6.21375H3.03597L2.67897 2.208H9.31422L9.19572 3.5325H9.19497Z"
                                                fill="#2D3436" />
                                        </svg>
                                    </div>

                                    <img class="hp-logo hp-sidebar-visible hp-dark-none" src="@/assets/img/favicon.png"
                                        alt="logo">
                                    <img class="hp-logo hp-sidebar-visible hp-dark-block" src="@/assets/img/favicon.png"
                                        alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-none"
                                        src="@/assets/img/favicon.png" alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block"
                                        src="@/assets/img/favicon.png" alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none"
                                        src="@/assets/img/favicon.png" alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block"
                                        src="@/assets/img/favicon.png" alt="logo">
                                </div>

                                <div class="d-flex">
                                    <span
                                        class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1">v.1.0</span>
                                </div>
                            </div>
                        </div>

                        <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-hidden">
                            <div class="hp-cursor-pointer mb-4">
                                <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                        fill="#B2BEC3"></path>
                                    <path
                                        d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                        fill="#B2BEC3"></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <ul style="margin-top: 30px;">
                        <li>

                            <ul>
                                <li>
                                    <router-link :to="{ name: 'users' }" id="usersN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Users" data-bs-original-title="Users"
                                            aria-label="Users"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-People"></i>
                                            </span>


                                            <span class="titleS">Users</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'models' }" id="modelsN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Users" data-bs-original-title="Users"
                                            aria-label="Users"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-People"></i>
                                            </span>


                                            <span class="titleS">Models</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'payouts' }" id="payoutsN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Payouts"
                                            data-bs-original-title="Payouts" aria-label="Payouts"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Wallet"></i>
                                            </span>

                                            <span class="titleS">Payouts
                                                
                                            </span>

                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'ref' }" id="refN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Referrals"
                                            data-bs-original-title="Referrals" aria-label="Referrals"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Wallet"></i>
                                            </span>

                                            <span class="titleS">Referral payout
                                                
                                            </span>

                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'kyc' }" id="kycN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Kyc" data-bs-original-title="Kyc"
                                            aria-label="Kyc"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Category"></i>
                                            </span>


                                            <span class="titleS">Kyc</span>

                                        

                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'reports' }" id="reportsN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Reports" data-bs-original-title="Reports"
                                            aria-label="reports"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Danger"></i>
                                            </span>


                                            <span class="titleS">Reports</span>

                                        

                                        </span>
                                    </router-link>
                                </li>

                                <li style="margin-top: 50px;">
                                    <button class="btn btn-primary" @click="refreshSubs"> 
                                        <i class="hp-text-color-dark-0 ri-2x ri-refresh-line" style="padding-right: 5px;"></i>
                                        Refresh subs
                                    </button>
                                </li>

                            </ul>

                        </li>


                    </ul>
                </div>


            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<style scoped>
.btn {
    color: #fff !important;
}

.shx {
    width: 1000px;
}

.shm {
    max-width: 800px;
    max-height: 500px;
    object-fit: cover;
}

@media only screen and (max-width: 666px) {

    .shx {
        width: 350px;

    }

    .shm {
        max-width: 300px;
        max-height: 300px;
        object-fit: cover;
    }

}
</style>

<script>

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, Timestamp, orderBy, deleteDoc, increment, setDoc, arrayRemove } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"
import { db } from '@/firebase';
import axios from "axios";

export default {

    data() {
        return {
            isLoggedIn: false,
            profilePic: "",
            fullName: "",
            userName: "",
            fanCount: "",
            followingCount: "",
            followersCount: "",
            email: "",
            loadingText: "",
            errorText: "",
            successText: "",
            mediaRawList: [],
            mediaUrlList: [],
            singleMediaName: "",
            singleMediaType: "",
            singleMediaUrl: "",

            caption: "",
            category: "",
            tags: "",
            price: "",

            postRefId: "",
            userType: "",

            mode: "",
            notiCount: 0,
            msgCount: 0,
            msgList:[],

            notiSub: null,

            supportPhone: "",
            supportMessage: "",
            supportCount: 0,
        }
    },

    mounted() {

        this.autocomplete();
        this.sider();
        //this.carousel();
        this.index();
        this.inputNumber();

        this.getUserInfo();
        this.getMode();

    },

    methods: {

        // MODULES
        sider() {
            $(function () {
                // Menu Link
                $(".hp-sidebar-container li a").each(function () {
                    if (window.location.pathname.split("/")[window.location.pathname.split("/").length - 1] == $(this).attr("href")) {
                        $(this).addClass("active")

                        $(this).parents(".submenu-children").slideDown()
                        $(this).parents(".submenu-children").addClass("active")
                        $(this).parents(".submenu-children").prev("a").addClass("active arrow-active")
                    }
                });

                // Menu Dropdown
                $(".hp-sidebar-container li a").click(function () {
                    if ($(this).next(".submenu-children").length) {
                        $(this).toggleClass("arrow-active")
                        $(this).next(".submenu-children").slideToggle(300)
                    }
                });

                // Mobile Button
                $(".hp-mobile-sidebar-button").click(function () {
                    $("body").removeClass("collapsed-active collapse-btn-none")
                });

                // Collapsed
                $(".hp-sidebar .hp-sidebar-collapse-button").click(function () {
                    $("body").toggleClass("collapsed-active")
                    $(".hp-sidebar .submenu-children").slideUp()
                    $(".hp-sidebar li a").removeClass("arrow-active")
                    $(".hp-sidebar .tooltip-item").toggleClass("in-active")



                    if ($("body").hasClass("collapsed-active")) {
                        $(".hp-sidebar .submenu-children").addClass("d-none")
                        document.getElementById("postBtn").style.display = "none";
                        document.getElementById("postBtn2").style.display = "";
                    } else {
                        $(".hp-sidebar .submenu-children").removeClass("d-none")
                        $(".hp-sidebar .submenu-children").css("display", "none")
                        document.getElementById("postBtn").style.display = "";
                        document.getElementById("postBtn2").style.display = "none";
                    }


                });

                if ($("body").hasClass("collapsed-active")) {
                    $(".hp-sidebar .submenu-children").addClass("d-none")
                    $(".hp-sidebar .tooltip-item").removeClass("in-active")


                }

                // Collapsed Menu Dropdown
                let position = "left";
                let sidebarWidth;

                if ($("html").attr("dir") === "rtl") {
                    position = "right";
                }

                $(".hp-sidebar-container li a").mouseenter(function () {
                    if ($("body").hasClass("collapsed-active")) {
                        sidebarWidth = parseInt($(this).parents(".hp-sidebar").width()) + 38;

                        $(".hp-sidebar-dropdown-container").remove();

                        if ($(this).next(".submenu-children").length) {
                            $("body").append(
                                `
                                        <div class="hp-sidebar-dropdown-container position-absolute">
                                            <ul>` +
                                $(this).next(".submenu-children").html() +
                                `</ul>
                                        </div>
                                        `
                            );

                            if ($(this).offset().top + $(".hp-sidebar-dropdown-container").height() > $(window).height()) {
                                $(".hp-sidebar-dropdown-container > ul").css({
                                    maxHeight: "calc(100vh - " + ($(window).height() - $(this).offset().top) + "px)",
                                });

                                $(".hp-sidebar-dropdown-container").css(
                                    "top", $(this).offset().top - $(".hp-sidebar-dropdown-container").height() + 50 + "px"
                                );
                                if (position === "right") {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, (sidebarWidth - 38) + "px"
                                    );
                                } else {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, "calc(" + $(this).offset().left + "px + " + sidebarWidth + "px)"
                                    );
                                }
                            } else {
                                $(".hp-sidebar-dropdown-container > ul").css({
                                    maxHeight: "none",
                                });

                                $(".hp-sidebar-dropdown-container").css(
                                    "top", $(this).offset().top + "px"
                                );
                                if (position === "right") {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, (sidebarWidth - 38) + "px"
                                    );
                                } else {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, "calc(" + $(this).offset().left + "px + " + sidebarWidth + "px)"
                                    );
                                }
                            }

                            //--

                            let levelNumber;
                            $(".hp-sidebar-dropdown-container li a").mouseenter(function () {
                                if ($(this).next(".submenu-children").length) {
                                    $(this).css("pointer-events", "none");

                                    levelNumber = $(this)
                                        .next(".collapse")
                                        .find(".submenu-children")
                                        .data("level");

                                    $("body").append(
                                        `
                                                <div class="hp-sidebar-dropdown-container position-absolute" data-level="` +
                                        levelNumber +
                                        `">
                                                    <ul>` +
                                        $(this).next(".submenu-children").html() +
                                        `</ul>
                                                </div>
                                                `
                                    );

                                    if ($(this).offset().top + $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").height() > $(window).height()) {
                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "] > ul").css({
                                            maxHeight: "calc(100vh - " + ($(window).height() - $(this).offset().top) + "px)",
                                        });

                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                            "top", $(this).offset().top - $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").height() + 50 + "px"
                                        );

                                        if (position === "right") {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + ($(this).width() + sidebarWidth - 38 + 27) + "px)"
                                            );
                                        } else {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + $(this).offset().left + "px + " + (sidebarWidth - 37) * parseInt(levelNumber) + "px)"
                                            );
                                        }
                                    } else {
                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "] > ul").css({
                                            maxHeight: "none",
                                        });

                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css("top", $(this).offset().top + "px");
                                        if (position === "right") {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + ($(this).width() + sidebarWidth - 38 + 27) + "px)"
                                            );
                                        } else {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + $(this).offset().left + "px + " + (sidebarWidth - 37) * parseInt(levelNumber) + "px)"
                                            );
                                        }
                                    }
                                } else {
                                    $(".hp-sidebar-dropdown-container li a").css("pointer-events", "all");
                                    $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").remove();
                                }
                            });
                        }
                    } else {
                        $(".hp-sidebar-dropdown-container").remove();
                    }
                });

                $(window).mousemove(function (e) {
                    let menuItem = $(".hp-sidebar-container li a");
                    let dropdownContainer = $(".hp-sidebar-dropdown-container");

                    if (
                        !menuItem.is(event.target) &&
                        !menuItem.has(event.target).length &&
                        !dropdownContainer.is(event.target) &&
                        !dropdownContainer.has(event.target).length
                    ) {
                        $(".hp-sidebar-dropdown-container").remove();
                        $(".hp-sidebar-dropdown-container li a").css("pointer-events", "all");
                    }
                });
            })
        },

        autocomplete() {

            !(function (e) {
                "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery);
            })(function (e) {
                function t(s, i) {
                    var n = function () { };
                    n = {
                        autoSelectFirst: !1,
                        appendTo: "body",
                        serviceUrl: null,
                        lookup: null,
                        onSelect: null,
                        width: "auto",
                        minChars: 1,
                        maxHeight: 300,
                        deferRequestBy: 0,
                        params: {},
                        formatResult: t.formatResult,
                        delimiter: null,
                        zIndex: 9999,
                        type: "GET",
                        noCache: !1,
                        onSearchStart: n,
                        onSearchComplete: n,
                        containerClass: "autocomplete-suggestions",
                        tabDisabled: !1,
                        dataType: "text",
                        lookupFilter: function (e, t, s) {
                            return -1 !== e.value.toLowerCase().indexOf(s);
                        },
                        paramName: "query",
                        transformResult: function (t) {
                            return "string" == typeof t ? e.parseJSON(t) : t;
                        },
                    };
                    (this.element = s),
                        (this.el = e(s)),
                        (this.suggestions = []),
                        (this.badQueries = []),
                        (this.selectedIndex = -1),
                        (this.currentValue = this.element.value),
                        (this.intervalId = 0),
                        (this.cachedResponse = []),
                        (this.onChange = this.onChangeInterval = null),
                        (this.isLocal = this.ignoreValueChange = !1),
                        (this.suggestionsContainer = null),
                        (this.options = e.extend({}, n, i)),
                        (this.classes = {
                            selected: "autocomplete-selected",
                            suggestion: "autocomplete-suggestion",
                        }),
                        this.initialize(),
                        this.setOptions(i);
                }
                var s = {
                    extend: function (t, s) {
                        return e.extend(t, s);
                    },
                    createNode: function (e) {
                        var t = document.createElement("div");
                        return (t.innerHTML = e), t.firstChild;
                    },
                };
                (t.utils = s),
                    (e.Autocomplete = t),
                    (t.formatResult = function (e, t) {
                        var s =
                            "(" +
                            t.replace(
                                RegExp("(\\/|\\.|\\*|\\+|\\?|\\||\\(|\\)|\\[|\\]|\\{|\\}|\\\\)", "g"),
                                "\\$1"
                            ) +
                            ")";
                        return e.value.replace(RegExp(s, "gi"), "<strong>$1</strong>");
                    }),
                    (t.prototype = {
                        killerFn: null,
                        initialize: function () {
                            var s,
                                i = this,
                                n = "." + i.classes.suggestion,
                                o = i.classes.selected,
                                l = i.options;
                            i.element.setAttribute("autocomplete", "off"),
                                (i.killerFn = function (t) {
                                    0 === e(t.target).closest("." + i.options.containerClass).length &&
                                        (i.killSuggestions(), i.disableKillerFn());
                                }),
                                (l.width && "auto" !== l.width) || (l.width = i.el.outerWidth()),
                                (i.suggestionsContainer = t.utils.createNode(
                                    '<div class="' +
                                    l.containerClass +
                                    '" style="position: absolute; display: none;"></div>'
                                )),
                                (s = e(i.suggestionsContainer)).appendTo(l.appendTo).width(l.width),
                                s.on("mouseover.autocomplete", n, function () {
                                    i.activate(e(this).data("index"));
                                }),
                                s.on("mouseout.autocomplete", function () {
                                    (i.selectedIndex = -1), s.children("." + o).removeClass(o);
                                }),
                                s.on("click.autocomplete", n, function () {
                                    i.select(e(this).data("index"), !1);
                                }),
                                i.fixPosition(),
                                window.opera
                                    ? i.el.on("keypress.autocomplete", function (e) {
                                        i.onKeyPress(e);
                                    })
                                    : i.el.on("keydown.autocomplete", function (e) {
                                        i.onKeyPress(e);
                                    }),
                                i.el.on("keyup.autocomplete", function (e) {
                                    i.onKeyUp(e);
                                }),
                                i.el.on("blur.autocomplete", function () {
                                    i.onBlur();
                                }),
                                i.el.on("focus.autocomplete", function () {
                                    i.fixPosition();
                                });
                        },
                        onBlur: function () {
                            this.enableKillerFn();
                        },
                        setOptions: function (t) {
                            var i = this.options;
                            s.extend(i, t),
                                (this.isLocal = e.isArray(i.lookup)) &&
                                (i.lookup = this.verifySuggestionsFormat(i.lookup)),
                                e(this.suggestionsContainer).css({
                                    "max-height": i.maxHeight + "px",
                                    width: i.width + "px",
                                    "z-index": i.zIndex,
                                });
                        },
                        clearCache: function () {
                            (this.cachedResponse = []), (this.badQueries = []);
                        },
                        clear: function () {
                            this.clearCache(), (this.currentValue = null), (this.suggestions = []);
                        },
                        disable: function () {
                            this.disabled = !0;
                        },
                        enable: function () {
                            this.disabled = !1;
                        },
                        fixPosition: function () {
                            var t;
                            "body" === this.options.appendTo &&
                                ((t = this.el.offset()),
                                    e(this.suggestionsContainer).css({
                                        top: t.top + this.el.outerHeight() + "px",
                                        left: t.left + "px",
                                    }));
                        },
                        enableKillerFn: function () {
                            e(document).on("click.autocomplete", this.killerFn);
                        },
                        disableKillerFn: function () {
                            e(document).off("click.autocomplete", this.killerFn);
                        },
                        killSuggestions: function () {
                            var e = this;
                            e.stopKillSuggestions(),
                                (e.intervalId = window.setInterval(function () {
                                    e.hide(), e.stopKillSuggestions();
                                }, 300));
                        },
                        stopKillSuggestions: function () {
                            window.clearInterval(this.intervalId);
                        },
                        onKeyPress: function (e) {
                            if (
                                this.disabled ||
                                this.visible ||
                                40 !== e.keyCode ||
                                !this.currentValue
                            ) {
                                if (!this.disabled && this.visible) {
                                    switch (e.keyCode) {
                                        case 27:
                                            this.el.val(this.currentValue), this.hide();
                                            break;
                                        case 9:
                                        case 13:
                                            if (-1 === this.selectedIndex) return void this.hide();
                                            if (
                                                (this.select(this.selectedIndex, 13 === e.keyCode),
                                                    9 === e.keyCode && !1 === this.options.tabDisabled)
                                            )
                                                return;
                                            break;
                                        case 38:
                                            this.moveUp();
                                            break;
                                        case 40:
                                            this.moveDown();
                                            break;
                                        default:
                                            return;
                                    }
                                    e.stopImmediatePropagation(), e.preventDefault();
                                }
                            } else this.suggest();
                        },
                        onKeyUp: function (e) {
                            var t = this;
                            if (!t.disabled) {
                                switch (e.keyCode) {
                                    case 38:
                                    case 40:
                                        return;
                                }
                                clearInterval(t.onChangeInterval),
                                    t.currentValue !== t.el.val() &&
                                    (0 < t.options.deferRequestBy
                                        ? (t.onChangeInterval = setInterval(function () {
                                            t.onValueChange();
                                        }, t.options.deferRequestBy))
                                        : t.onValueChange());
                            }
                        },
                        onValueChange: function () {
                            var e;
                            clearInterval(this.onChangeInterval),
                                (this.currentValue = this.element.value),
                                (e = this.getQuery(this.currentValue)),
                                (this.selectedIndex = -1),
                                this.ignoreValueChange
                                    ? (this.ignoreValueChange = !1)
                                    : e.length < this.options.minChars
                                        ? this.hide()
                                        : this.getSuggestions(e);
                        },
                        getQuery: function (t) {
                            var s = this.options.delimiter;
                            return s ? ((t = t.split(s)), e.trim(t[t.length - 1])) : e.trim(t);
                        },
                        getSuggestionsLocal: function (t) {
                            var s = t.toLowerCase(),
                                i = this.options.lookupFilter;
                            return {
                                suggestions: e.grep(this.options.lookup, function (e) {
                                    return i(e, t, s);
                                }),
                            };
                        },
                        getSuggestions: function (t) {
                            var s,
                                i = this,
                                n = i.options,
                                o = n.serviceUrl;
                            (s = i.isLocal ? i.getSuggestionsLocal(t) : i.cachedResponse[t]) &&
                                e.isArray(s.suggestions)
                                ? ((i.suggestions = s.suggestions), i.suggest())
                                : i.isBadQuery(t) ||
                                ((n.params[n.paramName] = t),
                                    !1 !== n.onSearchStart.call(i.element, n.params) &&
                                    (e.isFunction(n.serviceUrl) &&
                                        (o = n.serviceUrl.call(i.element, t)),
                                        e
                                            .ajax({
                                                url: o,
                                                data: n.ignoreParams ? null : n.params,
                                                type: n.type,
                                                dataType: n.dataType,
                                            })
                                            .done(function (e) {
                                                i.processResponse(e, t),
                                                    n.onSearchComplete.call(i.element, t);
                                            })));
                        },
                        isBadQuery: function (e) {
                            for (var t = this.badQueries, s = t.length; s--;)
                                if (0 === e.indexOf(t[s])) return !0;
                            return !1;
                        },
                        hide: function () {
                            (this.visible = !1),
                                (this.selectedIndex = -1),
                                e(this.suggestionsContainer).hide();
                        },
                        suggest: function () {
                            if (0 === this.suggestions.length) this.hide();
                            else {
                                var t = this.options.formatResult,
                                    s = this.getQuery(this.currentValue),
                                    i = this.classes.suggestion,
                                    n = this.classes.selected,
                                    o = e(this.suggestionsContainer),
                                    l = "";
                                e.each(this.suggestions, function (e, n) {
                                    l +=
                                        '<div class="' +
                                        i +
                                        '" data-index="' +
                                        e +
                                        '">' +
                                        t(n, s) +
                                        "</div>";
                                }),
                                    o.html(l).show(),
                                    (this.visible = !0),
                                    this.options.autoSelectFirst &&
                                    ((this.selectedIndex = 0), o.children().first().addClass(n));
                            }
                        },
                        verifySuggestionsFormat: function (t) {
                            return t.length && "string" == typeof t[0]
                                ? e.map(t, function (e) {
                                    return { value: e, data: null };
                                })
                                : t;
                        },
                        processResponse: function (e, t) {
                            var s = this.options,
                                i = s.transformResult(e, t);
                            (i.suggestions = this.verifySuggestionsFormat(i.suggestions)),
                                s.noCache ||
                                ((this.cachedResponse[i[s.paramName]] = i),
                                    0 === i.suggestions.length && this.badQueries.push(i[s.paramName])),
                                t === this.getQuery(this.currentValue) &&
                                ((this.suggestions = i.suggestions), this.suggest());
                        },
                        activate: function (t) {
                            var s = this.classes.selected,
                                i = e(this.suggestionsContainer),
                                n = i.children();
                            return (
                                i.children("." + s).removeClass(s),
                                (this.selectedIndex = t),
                                -1 !== this.selectedIndex && n.length > this.selectedIndex
                                    ? ((t = n.get(this.selectedIndex)), e(t).addClass(s), t)
                                    : null
                            );
                        },
                        select: function (e, t) {
                            var s = this.suggestions[e];
                            s &&
                                (this.el.val(s),
                                    (this.ignoreValueChange = t),
                                    this.hide(),
                                    this.onSelect(e));
                        },
                        moveUp: function () {
                            -1 !== this.selectedIndex &&
                                (0 === this.selectedIndex
                                    ? (e(this.suggestionsContainer)
                                        .children()
                                        .first()
                                        .removeClass(this.classes.selected),
                                        (this.selectedIndex = -1),
                                        this.el.val(this.currentValue))
                                    : this.adjustScroll(this.selectedIndex - 1));
                        },
                        moveDown: function () {
                            this.selectedIndex !== this.suggestions.length - 1 &&
                                this.adjustScroll(this.selectedIndex + 1);
                        },
                        adjustScroll: function (t) {
                            var s,
                                i,
                                n = this.activate(t);
                            n &&
                                ((n = n.offsetTop),
                                    (i =
                                        (s = e(this.suggestionsContainer).scrollTop()) +
                                        this.options.maxHeight -
                                        25),
                                    n < s
                                        ? e(this.suggestionsContainer).scrollTop(n)
                                        : n > i &&
                                        e(this.suggestionsContainer).scrollTop(
                                            n - this.options.maxHeight + 25
                                        ),
                                    this.el.val(this.getValue(this.suggestions[t].value)));
                        },
                        onSelect: function (t) {
                            var s = this.options.onSelect;
                            (t = this.suggestions[t]),
                                this.el.val(this.getValue(t.value)),
                                e.isFunction(s) && s.call(this.element, t);
                        },
                        getValue: function (e) {
                            var t,
                                s = this.options.delimiter;
                            return s
                                ? 1 === (s = (t = this.currentValue).split(s)).length
                                    ? e
                                    : t.substr(0, t.length - s[s.length - 1].length) + e
                                : e;
                        },
                        dispose: function () {
                            this.el.off(".autocomplete").removeData("autocomplete"),
                                this.disableKillerFn(),
                                e(this.suggestionsContainer).remove();
                        },
                    }),
                    (e.fn.autocomplete = function (s, i) {
                        return 0 === arguments.length
                            ? this.first().data("autocomplete")
                            : this.each(function () {
                                var n = e(this),
                                    o = n.data("autocomplete");
                                "string" == typeof s
                                    ? o && "function" == typeof o[s] && o[s](i)
                                    : (o && o.dispose && o.dispose(),
                                        (o = new t(this, s)),
                                        n.data("autocomplete", o));
                            });
                    });
            });


        },

        carousel() {
            // Carousel
            new bootstrap.Carousel();

        },

        index() {
            // Scroll to Top
            $(".scroll-to-top").click(function () {
                $(window).scrollTop(0)
            });

            $(window).scroll(function () {
                if ($(this).scrollTop() > (window.innerHeight / 3)) {
                    $(".scroll-to-top").addClass("active")
                } else {
                    $(".scroll-to-top").removeClass("active")
                }
            });

            // Wish Button
            $(".hp-wish-button").click(function () {
                $(this).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger")
                $(this).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90")
            });

            //BOOKMARK BUTTON
            $(".hp-book-button").click(function () {
                $(this).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary")
                $(this).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90")
            });

            // Date Timer (Page Error Coming Soon)
            $(".data-date-timer").each(function () {
                if ($(this).data("date-timer")) {
                    setInterval(() => {
                        let future = Date.parse($(this).data("date-timer")),
                            now = new Date(),
                            diff = future - now,
                            days = Math.floor(diff / (1000 * 60 * 60 * 24)),
                            hours = Math.floor(diff / (1000 * 60 * 60)),
                            mins = Math.floor(diff / (1000 * 60)),
                            secs = Math.floor(diff / 1000),
                            d = days,
                            h = hours - days * 24,
                            m = mins - hours * 60,
                            s = secs - mins * 60;

                        $(this).find("*[data-date-timer-day]").text(d)
                        $(this).find("*[data-date-timer-hours]").text(h)
                        $(this).find("*[data-date-timer-minutes]").text(m)
                        $(this).find("*[data-date-timer-seconds]").text(s)
                    }, 1000);
                }
            });

            // Search (Icon Search)
            $("*[data-search]").keyup(function () {
                let value = $(this).val();
                let patt = new RegExp(value, "i");

                $("*[data-search-item]").each(function () {
                    if (!($(this).find("*[data-search-item-text]").text().search(patt) >= 0)) {
                        $(this).hide();
                    }
                    if (($(this).find("*[data-search-item-text]").text().search(patt) >= 0)) {
                        $(this).show();
                    }
                });
            });

            // Copy Text
            setTimeout(() => {
                $("*[data-copy-click]").each(function () {
                    let itemId = $(this).find("*[data-copy-id]")

                    if ($(this).data("copy-click") === "value") {
                        $(this).find("*[data-copy-click-id]").click(function (e) {
                            if ($(this).data("copy-click-id") === itemId.data("copy-id")) {
                                let copyText = itemId.val();

                                navigator.clipboard.writeText(copyText);
                            }
                        })
                    } else {
                        $(this).find("*[data-copy-click-id]").click(function (e) {
                            if ($(this).data("copy-click-id") === itemId.data("copy-id")) {
                                if (itemId.find("*[data-copy]")) {
                                    navigator.clipboard.writeText(itemId.find("*[data-copy]").data("copy"));
                                } else {
                                    navigator.clipboard.writeText(itemId.text());
                                }
                            }
                        })
                    }
                });
            }, 300);

            // Payment Input Mask
            $('#payment-cardnumber').mask('0000 0000 0000 0000');
            $('#payment-date').mask('00/00');
            $('#payment-cvc').mask('000');
            $('#phone').mask('(000) 000-0000');

            // Tooltip
            let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            })

        },

        inputNumber() {
            // Input Number Component
            $(".input-number .input-number-input").focusin(function () {
                $(this).parent().parent().addClass("input-number-focused")
            });

            $(".input-number .input-number-input").focusout(function () {
                $(this).parent().parent().removeClass("input-number-focused")
            });

            $(".input-number .input-number-input").keyup(function () {
                let inputNumberUp = $(this).parents(".input-number").find(".input-number-handler-up"),
                    inputNumberDown = $(this).parents(".input-number").find(" .input-number-handler-down");

                if (Number($(this).val()) >= $(this).attr("max")) {
                    $(this).val($(this).attr("max"))

                    inputNumberUp.addClass("input-number-handler-up-disabled")
                    inputNumberDown.removeClass("input-number-handler-down-disabled")
                } else {
                    inputNumberDown.removeClass("input-number-handler-down-disabled")
                    inputNumberUp.removeClass("input-number-handler-up-disabled")
                }

                if ($(this).val() !== "") {
                    if (Number($(this).val()) <= $(this).attr("min")) {
                        $(this).val($(this).attr("min"))

                        inputNumberDown.addClass("input-number-handler-down-disabled")
                        inputNumberUp.removeClass("input-number-handler-up-disabled")
                    }
                }
            });

            $(".input-number .input-number-handler").click(function () {
                let inputNumberInput = $(this).parents(".input-number").find(".input-number-input"),
                    inputNumberUp = $(this).parents(".input-number").find(".input-number-handler-up"),
                    inputNumberDown = $(this).parents(".input-number").find(".input-number-handler-down"),
                    inputNumberValue = Number(inputNumberInput.val()),
                    inputNumberStep = Number(inputNumberInput.attr("step")) ? Number(inputNumberInput.attr("step")) : 1,
                    inputNumberMin = Number(inputNumberInput.attr("min")),
                    inputNumberMax = Number(inputNumberInput.attr("max"));

                if (!$(this).hasClass("input-number-handler-up-disabled")) {
                    if ($(this).hasClass("input-number-handler-up")) {
                        if (inputNumberValue < inputNumberMax) {
                            inputNumberValue += inputNumberStep;
                            inputNumberDown.removeClass("input-number-handler-down-disabled")
                        }

                        if (inputNumberValue === inputNumberMax) {
                            inputNumberUp.addClass("input-number-handler-up-disabled")
                        }
                    }
                }

                if (!$(this).hasClass("input-number-handler-down-disabled")) {
                    if ($(this).hasClass("input-number-handler-down")) {
                        if (inputNumberValue > inputNumberMin) {
                            inputNumberValue -= inputNumberStep;
                            inputNumberUp.removeClass("input-number-handler-up-disabled")
                        }

                        if (inputNumberValue === inputNumberMin) {
                            inputNumberDown.addClass("input-number-handler-down-disabled")
                        }
                    }
                }

                inputNumberInput.val(inputNumberValue)
            });

        },

        // MAIN

        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

        },

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        round(num, decimals){
            return +(Math.round(num + "e" + decimals) + "e-" + decimals);
        },

        async getUserInfo() {

            const auth = getAuth();

            onAuthStateChanged(auth, (user) => {

                if (user) {
                    this.isLoggedIn = true;
                }
                else {
                    this.isLoggedIn = false;
                    this.$router.push({ name: 'sign-in' });
                    return;
                }

            });


        },

        handleSignOut() {

            const auth = getAuth();

            signOut(auth).then(() => {
                sessionStorage.clear();
                localStorage.clear();
                this.$router.push({ name: 'sign-in' });
            })
        },

        getMode() {

            if (localStorage.getItem("fbayz_mode") == null || localStorage.getItem("fbayz_mode") == '') {
                this.mode = 'light';
                localStorage.setItem("fbayz_mode", "light");
                return;
            }

            this.mode = localStorage.getItem("fbayz_mode");

            if (this.mode == "light") {
                document.body.classList.add("light");
                document.body.classList.remove("dark");
            }

            if (this.mode == "dark") {
                document.body.classList.add("dark");
                document.body.classList.remove("light");
            }


        },

        setToLight() {
            document.body.classList.add("light");
            document.body.classList.remove("dark");
            localStorage.setItem("fbayz_mode", "light");
            this.$router.go();
        },

        setToDark() {
            document.body.classList.remove("light");
            document.body.classList.add("dark");
            localStorage.setItem("fbayz_mode", "dark");
            this.$router.go();
        },

        supportMail(){

            this.supportCount++;
            this.loadingText = "Sending message...";
            this.$refs.loadingModal.classList.add("bg-active");

            if(this.supportCount > 3){
                this.errorText = "Sending multiple messages in a row could be seen as spam. Your account could get flagged.";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            if(this.supportPhone == ""){
                this.supportPhone = "none";
            }

            //send mail
            axios.post('https://api.baesnap.com/v1/support-mail', {
                    toName: sessionStorage.getItem("fullName"),
                    toUsername: sessionStorage.getItem("userName"),
                    toEmail: sessionStorage.getItem("email"),
                    toPhone: this.supportPhone,
                    message: this.supportMessage
            })
            .then((response) => {
                
                this.successText = "Your message was sent successfully. We will get back to you soon."
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
                    
            })


        },

        async refreshSubs(){

            //start loading
            this.loadingText= "Checking expiration for all subscriptions...";
            this.$refs.loadingModal.classList.add("bg-active");

            //get Users with subs
            let userList=[]
            const adminRef = doc(db, "AdminInfo", "info");
            const adminSnap = await getDoc(adminRef);

            if (adminSnap.exists()){
                userList = adminSnap.data().subList;

                for(let i=0; i < userList.length; i++){
                    await this.checkExpired(userList[i])
                }
            }

            this.$refs.loadingModal.classList.remove("bg-active");
        },

        async checkExpired(userId) {

            let todaySecs = Timestamp.now().seconds;

            //check balance
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            let balance = userSnap.data().balance;
            let email = userSnap.data().email;
            let userName= userSnap.data().displayId;
            let fullName = userSnap.data().name;
            let profilePic = userSnap.data().profilePic;

            //my subscriptions
            const querySnapshot = await getDocs(collection(db, "UserSubs", userId, "Subs"));

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {

                    //send reminder
                    let daySec = doc.data().endDate - todaySecs;
                    let dDay = daySec / 86400
                    let dDayRound = this.round(dDay, 0);

                    // if(dDay > 0 && dDay < 7 ){

                    // }

                    if (todaySecs > doc.data().endDate && doc.data().status == 'active') {

                        if (balance >= doc.data().price) {
                            //renew sub
                            this.renewSub(balance, doc.data().duration, userId, doc.id, doc.data().modelUserName, doc.data().modelId, doc.data().price, doc.data().modelName, doc.data().modelProfilePic, doc.data().email, fullName, userName, profilePic);
                        }
                        else {

                            //send expiration mail to user
                            axios.post('https://api.baesnap.com/v1/expired-sub-mail', {
                                toName: fullName,
                                toEmail: email,
                                username: userName,
                            })
                            .then(function (response) {
                                console.log(response);

                            })

                            this.updateSub(userId, doc.id, doc.data().modelId, doc);
                        }

                    }

                });

            }

        },

        async updateSub(userId, subId, modelId, mDoc) {

            // const subRef = doc(db, "UserSubs", auth.currentUser.uid, "Subs", subId);
            // await updateDoc(subRef, {
            //     status: "expired",
            // });

            await setDoc(doc(db, "UserSubsE", userId, "SubsE", modelId), {
                price: mDoc.data().price,
                startDate: mDoc.data().startDate,
                duration: mDoc.data().duration,
                endDate: mDoc.data().endDate,
                status: "expired",
                modelId: modelId,
                modelName: mDoc.data().modelName,
                modelUserName: mDoc.data().modelUserName,
                modelProfilePic: mDoc.data().modelProfilePic,
            });

            await deleteDoc(doc(db, "UserSubs", userId, "Subs", modelId));
            await deleteDoc(doc(db, "UserFans", modelId, "Fans", userId));

            const modelRef = doc(db, "Users", modelId);
            await updateDoc(modelRef, {
                fanCount: increment(-1)
            });

            //remove from subList
            const adminRef = doc(db, "AdminInfo", "info");
            await updateDoc(adminRef, {
                subList: arrayRemove(userId)
            });

        },

        async renewSub(balance, days, userId, subId, modelUsername, modelId, price, modelName, modelProfilePic, modelEmail, uFullName, uUserName, uProfilePic) {

            let todaySecs = Timestamp.now().seconds;
            let durationSecs = days * 86400;
            let endDateSecs = todaySecs + durationSecs;

            //update user balance
            let newBalance = Number(balance) - Number(price)
            const balanceRef = doc(db, "Users", userId);
            await updateDoc(balanceRef, {
                balance: newBalance,
            });

            //update model balance
            const modelRef = doc(db, "Users", modelId);
            await updateDoc(modelRef, {
                balance: increment(Number(price)),
            });

            const subRef = doc(db, "UserSubs", userId, "Subs", subId);
            await updateDoc(subRef, {
                startDate: serverTimestamp(),
                endDate: endDateSecs,
            });

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs

            //update user tran
            await addDoc(collection(db, "UserTrans"), {
                idD: "BW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Subscription renewal",
                description: "Renewed Subscription to @" + modelUsername + " for another " + days + " days",
                amount: price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: secs,
                status: "successful",
                userId: userId,
                fullName: modelName,
                username: modelUsername,
                profilePic: modelProfilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "BD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Subscription",
                description: "@" + uUserName + " subscribed to your content for another " + days + " days",
                amount: price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: secs,
                status: "successful",
                userId: modelId,
                username: uUserName,
                fullName: uFullName,
                profilePic: uProfilePic,

            });

            axios.post('https://api.baesnap.com/v1/renew-sub-mail', {
                toName: modelName,
                toEmail: modelEmail,
                username: "@" + uUserName,
                amount: Number(price).toLocaleString("us-Us"),
                duration: days
            })
                .then(function (response) {
                    console.log(response);

                })

        },

    }

}

</script>